export const DATABASE_AUTHORIZATION_STORE_KEY = 'authorization';
